import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { SportEvent, MappingType } from 'videoservice-openapi-react';
import { useBroadcastStore, useUpdateBroadcastInCache } from 'entities/broadcast';
import { IUseMapEventsOptions } from './use-map-events.types';

export const useMapEvents = ({ broadcast, eventList, onSuccess }: IUseMapEventsOptions) => {
  const mapEvent = useBroadcastStore(state => state.addMapping);
  const { updateBroadcastItemCache } = useUpdateBroadcastInCache();

  const mapEventMutation = useMutation({
    mutationFn: (event: SportEvent) => {
      return mapEvent({
        broadcastId: broadcast.id,
        sbSportEventId: event.id,
        bindSportsBookEvent: {
          mappingType: MappingType.OPERATOR,
          description: event.description,
        },
      });
    },
    onSuccess(data) {
      updateBroadcastItemCache(data);
    },
  });

  const mapSelectedEvents = useCallback((selectedEvents: number[]) => {
    eventList
      .filter(event => selectedEvents.includes(event.id))
      .forEach(event => {
        mapEventMutation.mutate(event, {
          onSuccess() {
            if (typeof onSuccess === 'function')
              onSuccess();
          }
        });
      });
  }, [eventList, mapEventMutation, onSuccess]);

  return {
    mapSelectedEvents,
    mapEventMutation,
  };
};
